import axios, { AxiosInstance } from 'axios';
import { getBackendApiUrl } from '../config/env';

const BACKEND_API_URL = getBackendApiUrl();

class MonitoringService {
  private api: AxiosInstance;

  constructor() {
    this.api = axios.create({
      baseURL: `${BACKEND_API_URL}/api/v1/monitoring`,
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  async getStatus() {
    const response = await this.api.get('/status');
    return response.data.data;
  }

  async getLogs(lines: number = 100, errorsOnly: boolean = false) {
    const response = await this.api.get('/logs', { params: { lines, errors_only: errorsOnly } });
    return response.data.data;
  }

  async getWorkflowEvents(limit: number = 20) {
    const response = await this.api.get('/workflow-events', { params: { limit } });
    return response.data.data;
  }

  async getWorkflowEnrollments(limit: number = 20) {
    const response = await this.api.get('/workflow-enrollments', { params: { limit } });
    return response.data.data;
  }

  async getWorkflowExecutions(limit: number = 20) {
    const response = await this.api.get('/workflow-executions', { params: { limit } });
    return response.data.data;
  }

  async processPendingEvents() {
    const response = await this.api.post('/process-pending-events');
    return response.data.data;
  }

  async getNotificationLogs(lines: number = 100) {
    const response = await this.api.get('/notifications', { params: { lines } });
    return response.data.data;
  }

  async clearNotificationLogs() {
    const response = await this.api.post('/notifications/clear');
    return response.data;
  }
}

export const monitoringService = new MonitoringService();
export default monitoringService;

